module.exports = __webpack_public_path__ + "static/media/Sharandar1.913349b8.jpg";